import React from 'react';
import { FileText } from '@phosphor-icons/react';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-[#E8E9EB] dark:bg-[#121212]">
      {/* Header */}
      <div className="bg-[#0F172A] border-b-4 border-black py-12">
        <div className="max-w-4xl mx-auto px-4">
          <div className="flex items-center gap-4 mb-2">
            <div className="w-12 h-12 bg-[#D95800] border-2 border-white flex items-center justify-center">
              <FileText size={28} weight="bold" className="text-white" />
            </div>
            <div>
              <h1 className="text-3xl md:text-4xl font-black text-white uppercase">Terms of Service</h1>
              <p className="text-neutral-400">Last updated: January 2025</p>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="bg-white dark:bg-[#0F172A] border-4 border-black shadow-[8px_8px_0px_#D95800] p-6 md:p-8 space-y-8">
          
          <section>
            <h2 className="text-xl font-black uppercase mb-3 pb-2 border-b-2 border-black">1. Acceptance of Terms</h2>
            <p className="text-neutral-700 dark:text-neutral-300 leading-relaxed">
              By accessing and using ConstructHelp, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black uppercase mb-3 pb-2 border-b-2 border-black">2. User Accounts</h2>
            <p className="text-neutral-700 dark:text-neutral-300 leading-relaxed mb-4">
              You must create an account to use certain features of our platform. You are responsible for:
            </p>
            <ul className="space-y-2 text-neutral-700 dark:text-neutral-300">
              <li className="flex items-start gap-2">
                <span className="text-[#D95800] font-bold">•</span>
                Maintaining the security of your account credentials
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#D95800] font-bold">•</span>
                All activities that occur under your account
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#D95800] font-bold">•</span>
                Providing accurate and complete information
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#D95800] font-bold">•</span>
                Updating your information to keep it current
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-black uppercase mb-3 pb-2 border-b-2 border-black">3. User Conduct</h2>
            <p className="text-neutral-700 dark:text-neutral-300 leading-relaxed mb-4">
              You agree not to:
            </p>
            <ul className="space-y-2 text-neutral-700 dark:text-neutral-300">
              <li className="flex items-start gap-2">
                <span className="text-[#D95800] font-bold">•</span>
                Post false, misleading, or fraudulent information
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#D95800] font-bold">•</span>
                Harass, abuse, or harm other users
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#D95800] font-bold">•</span>
                Violate any laws or regulations
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#D95800] font-bold">•</span>
                Interfere with the proper functioning of the platform
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#D95800] font-bold">•</span>
                Use the platform for any unauthorized commercial purposes
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-black uppercase mb-3 pb-2 border-b-2 border-black">4. Payment Terms</h2>
            <p className="text-neutral-700 dark:text-neutral-300 leading-relaxed mb-4">
              Our platform uses escrow payments to ensure safe transactions:
            </p>
            <ul className="space-y-2 text-neutral-700 dark:text-neutral-300">
              <li className="flex items-start gap-2">
                <span className="text-[#D95800] font-bold">•</span>
                Payments are held securely until work is approved
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#D95800] font-bold">•</span>
                Service fees may apply to certain transactions
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#D95800] font-bold">•</span>
                Refunds are subject to our dispute resolution process
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-black uppercase mb-3 pb-2 border-b-2 border-black">5. Intellectual Property</h2>
            <p className="text-neutral-700 dark:text-neutral-300 leading-relaxed">
              All content on ConstructHelp, including logos, text, graphics, and software, is protected by intellectual property laws. You may not copy, modify, or distribute our content without permission.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black uppercase mb-3 pb-2 border-b-2 border-black">6. Limitation of Liability</h2>
            <p className="text-neutral-700 dark:text-neutral-300 leading-relaxed">
              ConstructHelp is a platform that connects contractors and workers. We do not guarantee the quality of work performed or the reliability of any user. Use our services at your own risk.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black uppercase mb-3 pb-2 border-b-2 border-black">7. Termination</h2>
            <p className="text-neutral-700 dark:text-neutral-300 leading-relaxed">
              We reserve the right to suspend or terminate your account at any time for violations of these terms or any other reason at our discretion.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black uppercase mb-3 pb-2 border-b-2 border-black">8. Contact</h2>
            <p className="text-neutral-700 dark:text-neutral-300 leading-relaxed">
              For questions about these Terms of Service, contact us at{' '}
              <a href="mailto:legal@constructhelp.com" className="text-[#D95800] hover:underline font-bold">
                legal@constructhelp.com
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
